import globalAxios from "../GlobalAxios";

const googleLogin = async () => {
  const res = await globalAxios.get("/api/auth/google");
  window.location.href = res.data.auth_url;
};

const callBack = async (code) => {
  const res = await globalAxios.get("/api/auth/callback", {params: {code}});
  return res.data;
};

// const uploadYouTube = async () => {
//   const res = await globalAxios.post("/api/youtube/upload");
//   return res.data;
// };

const uploadYouTube = async (params) => {
  try {
    // const token = sessionStorage.getItem("google_access_token");
    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${token}`
    //   }
    // };
    // const res = await globalAxios.post("/api/youtube/upload", null, config);
    const res = await globalAxios.post("/api/youtube/upload", {params})
    return res.data;
  } catch (error) {
    console.error("Error:", error);
    throw error; 
  }
};

export default {
    googleLogin,
    callBack,
    uploadYouTube,
};